import React, { useEffect, useState } from "react";
import "./FestivalSelectTemplate.scss";
import StandardTemplatesList from "./StandardTemplatesList";
import PersonalizedTemplatesList from "./PersonalizedTemplatesList";
import BrandTemplatesList from "./BrandTemplatesList";

interface AnnouncementType {
  name: string;
  value: string;
  slug: string;
}

interface AnnouncementSelectionTemplateProps {
  isOpen: boolean;
  onClose: () => void;
  festivalTypes: AnnouncementType;
  onConfirm?: (selectedTemplate: any) => void;
  existingTemplates?: string[];
}

const FestivalSelectTemplate: React.FC<
  AnnouncementSelectionTemplateProps
> = ({ isOpen, onClose, festivalTypes, onConfirm, existingTemplates }) => {
  const [activeTabId, setActiveTabId] = useState("1");
  const [selectedTemplates, setSelectedTemplates] = useState<any[]>([]);

  const selectTemplateTab = [
    { id: "1", title: "Standard Templates" },
    { id: "2", title: "Personalized Templates" },
    { id: "3", title: "Brand Templates" },
  ];

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleModalContentClick = (e: React.MouseEvent) => e.stopPropagation();

  const handleTemplateSelect = (template: any) => {
    setSelectedTemplates((prev) => {
      const exists = prev.find((t) => t.id === template.id);
      if (exists) return prev;
      return [...prev, template];
    });
  };

  const handleConfirm = () => {
    if (onConfirm && selectedTemplates.length > 0) {
      onConfirm(selectedTemplates);
    }
    onClose();
  };

  const renderTabContent = () => {
    const selectedIds = selectedTemplates.map((t) => t.id);

    switch (activeTabId) {
      case "1":
        return (
          <StandardTemplatesList
            selectedIds={selectedIds}
            onSelectTemplate={handleTemplateSelect}
            templateTypeIdProp={festivalTypes.value}
            festivalTypes={festivalTypes?.slug}
            existingTemplates={existingTemplates}
          />
        );

      case "2":
        return (
          <PersonalizedTemplatesList
            selectedIds={selectedIds}
            onSelectTemplate={handleTemplateSelect}
            templateTypeIdProp={festivalTypes.value}
            festivalTypes={festivalTypes?.slug}
            existingTemplates={existingTemplates}
          />
        );

      case "3":
        return (
          <BrandTemplatesList
            selectedIds={selectedIds}
            onSelectTemplate={handleTemplateSelect}
            templateTypeIdProp={festivalTypes.value}
            festivalTypes={festivalTypes?.slug}
            existingTemplates={existingTemplates}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="announcement-backdrop">
      <div className="announcement-main-container">
        <div className="announcement-content" onClick={handleModalContentClick}>
          <div className="announcement-header">
            <h2>{festivalTypes.name} Design Templates</h2>
          </div>

          <div className="announcement-tab-container">
            {selectTemplateTab.map((tab) => (
              <button
                key={tab.id}
                className={`announcement-tab-pill ${tab.id === activeTabId ? "active" : ""}`}
                onClick={() => setActiveTabId(tab.id)}
              >
                {tab.title}
              </button>
            ))}
          </div>

          <div className="announcement-body">{renderTabContent()}</div>

          <div className="announcement-footer">
            <button className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button
              className="done-btn"
              onClick={handleConfirm}
              disabled={selectedTemplates.length === 0}
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FestivalSelectTemplate;
